export enum RecommendationType {
  UnderOrOverPlanning = "underOrOverPlanning",
  EmissionToSolutionGap = "emissionToSolutionGap",
  IneffectiveSolutions = "ineffectiveSolutions",
}
